import React from "react";
import EmtyImg from "../../images/emty.svg";
function Emty(props) {
  return (
    <div>
      <div className="section-wrap flex flex-col justify-center items-center mt-24">
        <img src={EmtyImg} alt="" />
      </div>
      {/* <div className="text-center text-sm font-normal text-gray-300 mt-2">No {props.item} Found</div> */}
    </div>
  );
}

export default Emty;
